import { SectionWrapper } from "@/components/core/section-wrapper";
import type { PageIntro } from "@/types/site";

interface PageIntroSectionProps {
  content: PageIntro;
}

export function PageIntroSection({
  content,
}: PageIntroSectionProps): JSX.Element {
  return (
    <SectionWrapper
      eyebrow={content.eyebrow}
      heading={content.title}
      intro={content.description}
      className="pb-4 pt-12 md:pb-6 md:pt-16"
    >
      <div className="spotify-divider" />
    </SectionWrapper>
  );
}
